/* eslint-disable newline-before-return */
export function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "";
}

export function isEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim() === "";
}

export function toBool(value: unknown, defaultValue = false): boolean {
  return typeof value === "boolean" ? value : defaultValue;
}

export function isPlainObject(
  value: unknown,
): value is Record<string, unknown> {
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return false;
  }
  const proto = Object.getPrototypeOf(value);

  return proto === null || proto === Object.prototype;
}

export function sanitizeIdPart(str: unknown): string {
  return String(str).replace(/[.\s]+/g, "_");
}

export function isObject(value: unknown): value is Record<string, unknown> {
  return isPlainObject(value);
}

export function getValue<T>(obj: unknown, key: string, defaultValue: T): T {
  if (!isObject(obj)) return defaultValue;
  const value = (obj as Record<string, unknown>)[key];

  return value !== undefined ? (value as T) : defaultValue;
}

export function getString(
  obj: unknown,
  key: string,
  defaultValue = "",
): string {
  const value = getValue(obj, key, defaultValue);

  return String(value ?? "").trim();
}

export const indexFromKey = (s: string | number, fallback = -1): number => {
  const str = String(s);
  const m = str.match(/(\d+)/);
  return m ? Number(m[1]) : fallback;
};

export const toNumberOrUndefined = (v: unknown): number | undefined => {
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string" && v.trim() !== "" && !Number.isNaN(Number(v)))
    return Number(v);

  return undefined;
};

export const isValidNumber = (v: unknown): boolean => {
  if (typeof v === "number" && Number.isFinite(v) && !isNaN(v)) return true;

  return false;
};

export function isValidString(value: unknown): value is string {
  if (typeof value === "string") return true;

  return false;
}

export function isValidBoolean(value: unknown): value is boolean {
  if (typeof value === "boolean") return true;

  return false;
}

/**
 * Converts a value to a number, or returns a fallback if invalid.
 */
export const toNumber = (value: unknown, fallback = -1): number => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const n = Number(value.trim());
    if (!Number.isNaN(n) && Number.isFinite(n)) return n;
  }
  return fallback;
};
